<template>
  <div
    class="
      sticky inline-flex max-w-full gap-1.5 sm:gap-2 py-2 pr-1 lg:py-0 lg:pr-0
      items-center text-sm sm:text-base overflow-x-auto lg:overflow-x-visible
    "
  >
    <template v-if="report.type === 'personal'">
      <l-select
        v-if="locations"
        v-model="report.location"
        label="Location"
        class="
          flex items-center gap-3 shrink-0 text-sm order-last md:order-none sm:text-base
          label:sr-only md:label:not-sr-only
        "
        inline
        :items="locations"
        @input="input"
      />

      <l-radio-toggle
        v-model="report.source"
        label="Source"
        :items="[{ value: 'suggestions', text: 'Suggestions' }, { value: 'list', text: 'Your list' }]"
        class="label:sr-only"
        @input="input"
      />
    </template>

    <l-radio-toggle
      v-model="report.pt"
      label="Part-time"
      :items="[
        { value: '1', text: 'Part-time', color: 'violet' },
        { value: null, text: 'Full-time' },
      ]"
      class="label:sr-only"
      @input="input"
    />

    <slot/>
  </div>
</template>

<script setup>
import LRadioToggle from "@/components/inputs/LRadioToggle.vue"
import LSelect from "@/components/inputs/LSelect.vue"
import qs from "qs"
import { computed } from "vue"
import { useAuth } from "@/composables/useAuth"

const report = defineModel("report", Object)

const params = new URLSearchParams(window.location.search)

const { user } = useAuth()

const locations = computed(() => {
  const { location, wizard, type } = report.value

  if (location && type === "personal") {
    const options = [{ value: "all", text: "All" }]

    if (wizard.national) {
      options.push({ value: "national", text: "National schools" })
    }

    options.push(...user.value.statesPreferred.map(state => ({
      text: state.name,
      value: state.code,
    })))

    return options
  }

  return null
})

const input = () => {
  const { location, pt, source } = report.value

  window.location.href = window.location.pathname + qs.stringify({
    location: location === "all" ? null : location,
    source: source === "suggestions" ? null : source,
    pt,
    show: params.get("show"),
  }, {
    addQueryPrefix: true,
    skipNulls: true,
  })
}
</script>
